import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { RestTemplateModel } from '@template/models/rest-template-model.interface';

@Injectable({
  providedIn: 'root',
})
export class TemplatesCacheService {
  private _templatesCache = new BehaviorSubject<RestTemplateModel[]>([]);
  templatesCache$ = this._templatesCache.asObservable();

  getTemplatesCache(): RestTemplateModel[] {
    return this._templatesCache.getValue();
  }

  updateTemplatesCache(templates: RestTemplateModel[]) {
    this._templatesCache.next(templates);
  }

  resetTemplatesCache() {
    this._templatesCache.next([]);
  }
}
